var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.054,
    height: 212.42,
    viewBox: "0 0 232.054 212.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_logo",
    transform: "translate(-676.946 -1907)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(789 1979)",
    fill: "#202349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1818",
    "data-name": "Pfad 1818",
    d: "M7.574,26.911h25.3l7.572,28.994H-1.475Z",
    transform: "translate(786 1981)",
    fill: "#202349"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(702 1907)",
    fill: "none",
    stroke: "#202349",
    strokeWidth: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 103.5,
    r: 103.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 103.5,
    r: 95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1821",
    "data-name": "Pfad 1821",
    d: "M-13.573-49.325S36.616-43.078,51.907-.858,62.462,60.1,85.08,82.719s54.479,35.309,54.479,35.309-26.006,12.92-88.8-34.172C13.458,52.646,3.442,24.158.713,8.988,6.392-31.238-13.573-49.325-13.573-49.325Z",
    transform: "translate(708 1987)",
    fill: "#02598b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1820",
    "data-name": "Pfad 1820",
    d: "M-22.081-32.426S30.152-22.4,45.876,14.867,61.207,64.3,78.4,83.15c20.855,22.861,61.18,34.836,61.18,34.836S91.865,122.272,29.075,75.18C-8.23,43.97,1.549,31-1.18,15.83A59.558,59.558,0,0,0-22.081-32.426Z",
    transform: "translate(708 1987)",
    fill: "#008cc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1819",
    "data-name": "Pfad 1819",
    d: "M-31.054-10.763s52.375-11.2,80.162,57.941,90.528,70.809,90.528,70.809-50.92,37.923-113.71-9.17c-37.3-31.21-28.851-61.286-31.58-76.456C-13.411.042-31.054-10.763-31.054-10.763Z",
    transform: "translate(708 1987)",
    fill: "#5ec4e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.00d4199fd2a42d3184b7a7dcd7f4c43f.svg";
export { ForwardRef as ReactComponent };